import React from 'react';
import OnboardingLayout from 'components/OnboardingLayout';
import { useGlobalState } from 'hooks/useGlobalState';
import styles from './TimeoutScreen.module.scss';

export default function TimeoutScreen() {
  const [{ timeoutScreen }] = useGlobalState();

  return (
    timeoutScreen.visible && (
      <div className={styles.overlay} data-testid="timeoutScreen">
        <OnboardingLayout promptEnabled={false}>
          <h1 className={styles.h1}>New instance loading...</h1>
          <div className={styles.imgWrap}>
            <img
              src="/assets/images/blippi-timeout.svg"
              alt="Blippi the robot is looking perturbed."
            />
          </div>
          <h2 className={styles.h2}>
            Hmm... something unexpected occurred. But we’re working to get you
            up and running right away! Please check your email for updates.
          </h2>
        </OnboardingLayout>
      </div>
    )
  );
}
